// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
export const BASE_URL = ''; // If using proxy
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PURCHASE_URL = '/api/purchases';
export const BILL_URL = '/api/bills';
export const SALARY_URL = '/api/salarys';
export const TRANSPORT_URL = '/api/transports'
export const EXPENSE_URL = '/api/expenses';
export const OILCAKE_URL = '/api/oilcakes';
export const UPLOADS_URL = '/api/upload';